import {useEffect, useRef} from 'react'
import './InteractivePhone3D.css'

interface InteractivePhone3DProps {
  className?: string
}

const InteractivePhone3D = ({className}: InteractivePhone3DProps) => {
  const stageRef = useRef<HTMLDivElement>(null)
  const wrapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const stage = stageRef.current
    const wrap = wrapRef.current
    if (!stage || !wrap) return

    const state = {
      rotX: 6,
      rotY: -22,
      targetX: 6,
      targetY: -22,
      dragging: false,
      startX: 0,
      startY: 0,
      baseX: 6,
      baseY: -22,
    }
    const clamp = (v: number, mn: number, mx: number) => Math.max(mn, Math.min(mx, v))

    let raf = 0
    let t = 0
    const tick = () => {
      t += 1 / 60
      state.rotX += (state.targetX - state.rotX) * 0.12
      state.rotY += (state.targetY - state.rotY) * 0.12
      const idleY = state.dragging ? 0 : Math.sin(t * 0.9) * 8
      const idleZ = state.dragging ? 0 : Math.sin(t * 0.9 + 1) * 6
      wrap.style.transform = `rotateX(${state.rotX}deg) rotateY(${state.rotY}deg) translateY(${idleY}px) translateZ(${idleZ}px)`
      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)

    const handlePointerMove = (e: PointerEvent) => {
      if (!state.dragging) return
      const dx = e.clientX - state.startX
      const dy = e.clientY - state.startY
      state.targetY = clamp(state.baseY + dx * 0.35, -45, 45)
      state.targetX = clamp(state.baseX - dy * 0.25, -25, 25)
    }
    const handlePointerDown = (e: PointerEvent) => {
      state.dragging = true
      state.startX = e.clientX
      state.startY = e.clientY
      state.baseX = state.targetX
      state.baseY = state.targetY
      wrap.classList.add('is-dragging')
      stage.setPointerCapture(e.pointerId)
    }
    const handlePointerUp = (e: PointerEvent) => {
      state.dragging = false
      wrap.classList.remove('is-dragging')
      stage.releasePointerCapture(e.pointerId)
    }

    stage.addEventListener('pointermove', handlePointerMove)
    stage.addEventListener('pointerdown', handlePointerDown)
    stage.addEventListener('pointerup', handlePointerUp)
    stage.addEventListener('pointercancel', handlePointerUp)

    return () => {
      cancelAnimationFrame(raf)
      stage.removeEventListener('pointermove', handlePointerMove)
      stage.removeEventListener('pointerdown', handlePointerDown)
      stage.removeEventListener('pointerup', handlePointerUp)
      stage.removeEventListener('pointercancel', handlePointerUp)
    }
  }, [])

  return (
    <div className={`phone3d-stage${className ? ` ${className}` : ''}`} ref={stageRef}>
      <div className="phone3d-wrap" ref={wrapRef}>
        <div className="phone3d-glow" />
        <div className="phone3d-side" />
        <div className="phone3d-face">
          <div className="phone3d-logo" />
        </div>
      </div>
    </div>
  )
}

export default InteractivePhone3D
